import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueClipboard from 'vue-clipboard2'
import VConsole from "vconsole";
import {
  get,
  post
} from './axios/axios';
import { setRuntimeEnv } from "./utils/index";
setRuntimeEnv();
Vue.use(VueClipboard)
Vue.config.productionTip = false
// 忽略微信开放标签
Vue.config.ignoredElements = ['wx-open-launch-weapp', 'wx-open-launch-app','wx-open-subscribe', 'wx-open-audio'];

import dcpInstance from './dcp/index.js'
Vue.prototype.$dcpTrack = (type,name,data)=>{
  dcpInstance.track(type,name,data)
};
Vue.prototype.$get = get
Vue.prototype.$post = post
if (process.env.VUE_APP_ENV === 'qa') {
  new VConsole()
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')